import React from 'react';
import { BiPlus, BiTrash } from 'react-icons/bi';
import { Button } from '../../ui';
import { useBuilderEditor } from '../../../features/builder/BuilderEditorContext';
import { TableColumnType } from '../../../core/constants/common';

const TableEditor = () => {
  const {
    tableData, addTableColumn, removeTableColumn, handleTableColumnChange,
  } = useBuilderEditor();

  const sortedColumns = tableData.columns
    .map((col, index) => ({ col, index }))
    .sort((a, b) => (a.col.sortOrder ?? a.index + 1) - (b.col.sortOrder ?? b.index + 1));

  return (
    <div className="table-editor d-flex flex-column gap-3">
      <label className="builder-label">Columns</label>

      {tableData.columns.length > 0 && (
        <div className="d-flex flex-column gap-2">
          {sortedColumns.map(({ col, index }, displayIndex) => (
            <div key={index} className="d-flex align-items-center gap-2">
              <input
                className="builder-ui-input flex-grow-1"
                value={col.name || ''}
                onChange={(e) => handleTableColumnChange(index, 'name', e.target.value)}
                placeholder={`Column ${displayIndex + 1}`}
                required
              />
              <select
                className="builder-ui-select table-editor__type-select"
                value={col.columnType || TableColumnType.TEXT}
                onChange={(e) => handleTableColumnChange(index, 'columnType', e.target.value)}
              >
                <option value={TableColumnType.TEXT}>Text</option>
                <option value={TableColumnType.NUMERIC}>Numeric</option>
              </select>
              {col.columnType === TableColumnType.NUMERIC && (
                <>
                  <input
                    className="builder-ui-input table-editor__minmax-input"
                    type="number"
                    min="0"
                    placeholder="Min"
                    value={col.minimumValue ?? ''}
                    onChange={(e) => handleTableColumnChange(index, 'minimumValue', e.target.value)}
                  />
                  <input
                    className="builder-ui-input table-editor__minmax-input"
                    type="number"
                    min="0"
                    placeholder="Max"
                    value={col.maximumValue ?? ''}
                    onChange={(e) => handleTableColumnChange(index, 'maximumValue', e.target.value)}
                  />
                </>
              )}
              <label className="d-flex align-items-center gap-1 mb-0 text-nowrap small">
                <input
                  type="checkbox"
                  checked={!!col.required}
                  onChange={(e) => handleTableColumnChange(index, 'required', e.target.checked)}
                />
                Required
              </label>
              <Button variant="ghost" icon={<BiTrash />} aria-label="Remove column" onClick={() => removeTableColumn(index)} />
            </div>
          ))}
        </div>
      )}

      <Button variant="ghost" size="sm" icon={<BiPlus />} onClick={addTableColumn}>Add column</Button>
    </div>
  );
};

export default TableEditor;
